import PrequalApprovedScreen from 'features/lineOfCredit/screens/preApproved/PrequalApprovedScreen';
import React from 'react';

export default function Page() {
  return <PrequalApprovedScreen />;
}
